import { styled } from '@mui/material/styles';
import { color } from '../../../shared/styles';


export const StatusWrapper = styled('div')<{ isActive: boolean }>(({ theme, isActive }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
  fontSize: '11px',
  fontWeight: 600,
  borderRadius: '5px',
  padding: '4px 8px',
  backgroundColor: isActive ? color.status.SUCCESS_LIGHT : color.status.DANGER_LIGHT,
  color: isActive ? color.status.SUCCESS : color.status.FAIL,
  border: `1px solid ${color.emphasis.NEUTRAL_N10}`,
  lineHeight: '16px',
  height: '16px',
  textTransform: 'uppercase',
  '&::before': {
    content: '""',
    width: '4px',
    height: '4px',
    borderRadius: '50%',
    backgroundColor: isActive ? color.status.SUCCESS : color.status.FAIL,
    marginRight: '4px',
    flexShrink: 0,
  },
}));